export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  isDetailed: false,
  stickeyHeaders: true,
  rearrangeCols: false,
  permissionModule: 'scm',
  detailRowComponent: 'mf-detail-row',
  customRowKey: 'uid',
  gutterOpts: {
    buttons: [{
      event: 'columnChooser',
      icon: 'icon-tablecolumns',
      isLine: true,
      tooltip: 'Customise Columns',
    }],
  },
  toolBar: {
    // name: for drop down label, label: for action button label
    hideSearchBar: false, // by default let the search bar be available for the table
    buttons: [],
  },
  fields: [
    {
      title: 'Order Name',
      name: 'field-generic-input',
      prop: 'name',
      width: '400px',
      sticky: true,
      id: 'name',
      defaultVisible: true,
      alwaysVisible: true,
      isClickable: true,
      eventType: 'openCard',
      searchField: false, // to give a search bar for the field
      searchable: true, // to place any custom field in the header of the column like for below
      inputProps: {
        type: 'text',
      },
    }, {
      title: 'Project',
      name: 'field-generic-input',
      prop: 'project.name',
      sortField: 'project',
      searchable: true,
      filterText: 'Projects',
      width: '296px',
      id: 'project',
      isDisabled: true,
      defaultVisible: true,
      alwaysVisible: false,
    }, {
      title: 'Modified',
      name: 'dateOfChange',
      id: 'date',
      defaultVisible: true,
      alwaysVisible: false,
      dateFilter: 'Date',
      width: '152px',
      searchable: true,
    }, {
      title: 'Order Type',
      name: 'module',
      width: '196px',
      prop: 'module',
      id: 'module',
      filterText: 'Order Type',
      searchable: true,
      defaultVisible: true,
      alwaysVisible: false,
    }, {
      title: 'Old Stage',
      name: 'field-stage',
      width: '192px',
      prop: 'stageChange.oldValue',
      id: 'stageChange.oldValue',
      defaultVisible: true,
      alwaysVisible: false,
      searchable: true,
      sortField: 'stageChange.oldValue',
      filterText: 'Old Stage',
      cardProps: {
        cardType: '__t',
      },
    },
    {
      title: 'New Stage',
      name: 'field-stage',
      width: '192px',
      prop: 'stageChange.newValue',
      id: 'stageChange.newValue',
      sortField: 'stageChange.newValue',
      defaultVisible: true,
      alwaysVisible: false,
      searchable: true,
      filterText: 'New Stage',
      cardProps: {
        cardType: '__t',
      },
    },
    {
      title: 'Actions',
      name: 'table-field-actions',
      id: 'action',
      width: '112px',
      thAttrs: () => ({ class: 'action-sticky' }),
      tdClass: 'action-sticky',
      noRequiredCheck: true,
      sticky: true,
      hideFromChooser: true,
      alwaysVisible: true,
      searchable: true,
      clearBtn: true,
      inputProps: {
        showEdit: true,
      },
    },
  ],
};
